export default __webpack_public_path__ + "static/autonomous_shuttle-cc8e199cf8de8ad4154e58e460956c6e.png";